import actionTypes from './actionTypes';

const requestSeasons = () => ({
    type: actionTypes.REQUEST_SEASONS
});

const seasonsResponse = (success, seasons, error) => ({
    type: actionTypes.SEASONS_RESPONSE,
    payload: {
        success,
        seasons,
        errors: error
    }
});

export default {
    requestSeasons,
    seasonsResponse
};